<template>
  <div class="vh-100">
    <!-- HEADER -->
    <div class="header-top bg-white">
      <div
        class="header-top--inner w-limit d-flex justify-content-between align-items-center"
      >
        <div class="header-top--left" @click="backtolistpenggajian">
          <div class="header-item">
            <img src="../../../assets/icons/back-blue.svg" alt="a" />
          </div>
        </div>
        <div class="header-top--middle f-cont f-16 f-bold">Bayar Gaji</div>
        <div class="header-top--right">
          <div class="header-item"></div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="content-wrapper main-page flex-100">
      <div class="flex-1">
        <div class="p-x-20 m-t-16 m-d-20 w-limit mod">
          <label class="form-label require">Pilih Karyawan</label>
          <Select2
            class="test-select fl-is-required inputs"
            id="select2"
            :options="databayargaji.karyawan"
            :settings="{ placeholder: 'Pilih Karyawan' }"
            v-model="databayargaji.selected_karyawan_Faktur"
            @change="myChangeEventkaryawan($event)"
          />
        </div>
        <div class="separator"></div>
        <div class="m-t-16 p-x-20 w-limit">
          <div class="f-16 f-bold">Periode Pembayaran</div>
          <div class="f-14 m-t-4 f-ln-150 f-c-midgrey">
            Jangka waktu tertentu sebagai patokan perhitungan gaji berdasarkan
            hari kerja.
          </div>
          <div class="form-group mod m-t-16" id="nondissable_periodes">
            <label for="periode_awal" class="form-label require"
              >Periode Awal</label
            >
            <input
              type="date"
              class="form-control"
              id="periode_awal"
              v-model="databayargaji.input_date_awal_Faktur"
              :max="databayargaji.input_date_akhir_Faktur"
              :readonly="
                databayargaji.status_periode_Faktur ? 'readonly' : false
              "
            />
          </div>
          <div class="form-group mod m-t-16">
            <label for="periode_akhir" class="form-label require"
              >Periode Akhir</label
            >
            <input
              type="date"
              class="form-control"
              id="periode_akhir"
              :min="databayargaji.input_date_awal_Faktur"
              :max="this.getToday()"
              v-model="databayargaji.input_date_akhir_Faktur"
            />
          </div>
        </div>
      </div>
      <div class="button-wrapper p-x-20 p-y-20 w-limit w-100">
        <button
          class="btn smart-primary"
          id="BtnBayarGaji"
          @click="
            validateAccess('payroll.create') && cekconnection_Bayargaji(false)
          "
        >
          Berikutnya
        </button>
      </div>
    </div>

    <div class="modal fade" id="modal_setuju" role="dialog">
      <div class="modal-dialog modal-lg bani-modal">
        <div class="modal-content">
          <div class="modal-head w-limit">
            <div class="modal-head--left"></div>
            <h5 class="f-16 f-bold">Konfirmasi Pembayaran Gaji</h5>
            <div class="modal-head--right" data-dismiss="modal">
              <img src="../../../assets/img/x2.svg" alt="" />
            </div>
          </div>
          <div class="separator-line"></div>
          <div class="modal-bodyy w-limit w-100 p-x-20 p-y-20">
            <p>
              Pastikan Anda melakukan pembayaran gaji setelah karyawan
              <b> benar-benar selesai bekerja hari ini. </b>
              <br />
              Karena upah pekerjaan hari ini yang dikerjakan setelah pembayaran
              gaji (setelah Jam {{ getHourNow() }} WIB),
              <br />
              <b
                >tidak akan dihitung dalam penggajian sekarang maupun
                dipenggajian selanjutnya.</b
              >
              <br />
              <br />
              Apakah Anda yakin ingin melanjutkan bayar gaji?
            </p>
            <div
              class="custom-control custom-checkbox remove-padding mar-top-12"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                id="setuju"
                v-model="setuju"
              />
              <label class="custom-control-label" for="setuju"
                >Saya paham & setuju untuk melanjutkan</label
              >
            </div>

            <div class="button-wrapper p-t-12 p-d-20 w-limit w-100">
              <button
                class="btn smart-primary"
                :disabled="setuju ? false : 'disabled'"
                @click="
                  validateAccess('payroll.create') &&
                    cekconnection_Bayargaji(true)
                "
              >
                Lanjutkan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
export default {
  name: "BayarGaji",
  props: ["databayargaji"],
  components: {
    Select2,
  },
  data() {
    return {
      setuju: false,
      yesterday: "",
      requestHeaders: {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      },
    };
  },
  mounted() {
    this.GetListKaryawan();
    this.yesterday = this.getYesterday();
    this.databayargaji.input_date_akhir_Faktur = this.yesterday;
    if (this.databayargaji.selected_karyawan_Faktur != "") {
      this.myChangeEventkaryawan(this.databayargaji.selected_karyawan_Faktur);
    }

    this.backButtonPressed(this.backtolistpenggajian);
  },
  methods: {
    backtolistpenggajian() {
      this.$emit("backtolistpenggajian");
    },
    getYesterday() {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      var dd = String(yesterday.getDate()).padStart(2, "0");
      var mm = String(yesterday.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = yesterday.getFullYear();

      yesterday = yyyy + "-" + mm + "-" + dd;
      return yesterday;
    },
    getToday() {
      var today = new Date();
      // today.setDate(yesterday.getDate()+1);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },

    getHourNow() {
      var today = new Date();
      today =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0");
      return today;
    },

    async GetListKaryawan() {
      $("#loadingPage").addClass("overlayLoading");
      $("#loadingPage").show();
      this.databayargaji.karyawan = [];
      try {
        var idowner = localStorage.getItem("idowner");
        const res = await this.$axios.get(
          this.$baseurl +
            "/masterData/meta/list_karyawan_meta?idowner=" +
            idowner +
            "&limit=1000",
          this.requestHeaders
        );
        if (res.status === 200) {
          $("#loadingPage").removeClass("overlayLoading");
          $("#loadingPage").hide();
          $("#dissable_periode").hide();
          var rawworkshop = res.data.data;
          this.databayargaji.karyawan.push({ id: "", text: "Pilih Karyawan" });
          for (var i = 0; i < rawworkshop.length; i++) {
            this.databayargaji.karyawan.push({
              id: rawworkshop[i].idkaryawan,
              text: rawworkshop[i].nama,
            });
          }
        }
      } catch (e) {
        if (!e.code) {
          this.$catch_error_response(e);
        }
      }
    },

    myChangeEventkaryawan(val) {
      this.myValue = val;
      this.GetKaryawan_Salarry();
      // this.CekvalidateBtnBayar();
    },

    async GetKaryawan_Salarry() {
      this.databayargaji.Check_Karyawan = [];
      try {
        const res = await this.$axios.get(
          this.$baseurl +
            "/masterData/penggajian/meta/cek_periode_awal?" +
            "idkaryawan=" +
            this.databayargaji.selected_karyawan_Faktur,
          this.requestHeaders
        );
        if (res.data.status === true) {
          var rawworkshop = res.data.data;
          this.databayargaji.status_periode_Faktur =
            rawworkshop.status_periode_awal;
          if (rawworkshop.status_periode_awal) {
            this.databayargaji.input_date_awal_Faktur =
              rawworkshop.tanggal_awal;
          } else {
            this.databayargaji.input_date_awal_Faktur = this.getYesterday();
          }

          if (
            this.databayargaji.input_date_awal_Faktur >
            this.databayargaji.input_date_akhir_Faktur
          ) {
            this.databayargaji.input_date_akhir_Faktur = this.getToday();
          }
        }
      } catch (e) {
        this.$catch_error_response(e);
      }
    },

    // <!-- FUNGSI CEK KONEKSI IF 200 MENJALANKAN FUNGSI DOWNLOAD TEMPLATE -->
    async cekconnection_Bayargaji(forceNext) {
      var tgl_awal = this.databayargaji.input_date_awal_Faktur;
      var tgl_akhir = this.databayargaji.input_date_akhir_Faktur;
      var SelectKaryawan = this.databayargaji.selected_karyawan_Faktur;
      if (SelectKaryawan == "") {
        this.$toast.error("Mohon pilih karyawan terlebih dahulu");
        return;
      }
      if (tgl_akhir < tgl_awal) {
        this.$toast.error("Periode awal tidak boleh melebihi periode akhir");
        return;
      }
      if (tgl_akhir > this.getToday()) {
        this.$toast.error(
          "Periode akhir tidak boleh melebihi tanggal hari ini"
        );
        return;
      }
      if (!forceNext) {
        if (tgl_akhir === this.getToday()) {
          $("#modal_setuju").modal("show");
          return;
        }
      } else {
        $("#modal_setuju").modal("hide");
      }

      $("#loadingPage").show();
      $("#loadingPage").addClass("overlayLoading");
      try {
        const response = await this.$axios.get(
          this.$baseurl + "/masterData/meta/cek_koneksi",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        if (response.status === 200) {
          if (response.data.status === true) {
            this.$emit("gotofakturgaji");
            $("#loadingPage").hide();
            $("#loadingPage").removeClass("overlayLoading");
          } else {
            this.$toast.error(response.data.msg);
            $("#loadingPage").hide();
            $("#loadingPage").removeClass("overlayLoading");
          }
        }
      } catch (e) {
        this.$catch_error_response(e);
      }
    },
  },
};
</script>

<style></style>
